import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const AnalyticsDashboardAppConfig = {
  auth: [...authRoles.owner],
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.analytics,
      component: React.lazy(() => import('./AnalyticsDashboardApp')),
    },
  ],
};

export default AnalyticsDashboardAppConfig;
